/**
 * Listener для обновления баланса и истории транзакций
 * Срабатывает на все события, которые изменяют баланс или создают транзакции
 */

import { getUserControllerGetMeQueryKey } from '@/api/users/users'
import { client } from '@/features/query/client'
import { SseEventDtoEvent } from '@/api/model'
import { Listeners } from 'src/api/sse'
import { debounce } from 'lodash'

// Query key для истории транзакций кошелька
const TRANSACTIONS_QUERY_KEY = ['transactions', 'infinity', 'USDT']

// Debounced функция для объединения множественных инвалидаций
// Если приходит несколько событий подряд - выполнится только один запрос
const debouncedInvalidateWalletData = debounce(
  () => {
    // Обновляем баланс пользователя
    client.invalidateQueries({ queryKey: getUserControllerGetMeQueryKey() })

    // Обновляем историю транзакций
    client.invalidateQueries({ queryKey: TRANSACTIONS_QUERY_KEY })
  },
  500,
  { leading: false, trailing: true },
)

// Универсальный handler для всех событий, изменяющих баланс/транзакции
const invalidateWalletData = () => {
  debouncedInvalidateWalletData()
}

// Экспортируем listeners для регистрации в SSE Provider
export const withdrawalListeners: {
  [K in keyof Listeners]?: Listeners[K][number]
} = {
  // Withdrawal события - обновляют баланс и историю
  [SseEventDtoEvent.withdrawalrequested]: invalidateWalletData,
  [SseEventDtoEvent.withdrawalapproved]: invalidateWalletData,
  [SseEventDtoEvent.withdrawalrejected]: invalidateWalletData,
  [SseEventDtoEvent.withdrawalcompleted]: invalidateWalletData,
  [SseEventDtoEvent.withdrawalfailed]: invalidateWalletData,

  // Donation события - создают транзакции и меняют баланс
  [SseEventDtoEvent.donationreceived]: invalidateWalletData,
  [SseEventDtoEvent.donationconfirmed]: invalidateWalletData,

  // Dream события - закрытие дрима создает транзакции (комиссия + возврат средств)
  [SseEventDtoEvent.dreamclosed]: invalidateWalletData,
  [SseEventDtoEvent.dreamgoal_reached]: invalidateWalletData,

  // Transaction события - изменение статуса транзакций
  [SseEventDtoEvent.transactionconfirmed]: invalidateWalletData,
  [SseEventDtoEvent.transactionfailed]: invalidateWalletData,
  [SseEventDtoEvent.transactionstatus_changed]: invalidateWalletData,
} as const
